const createQuery = () => `
query Showtimes($mxfReleaseId: String!, $latitude: Float, $longitude: Float, $postcode: String){
  showtimes(mxfReleaseId: $mxfReleaseId, position: {latitude: $latitude, longitude: $longitude, postcode: $postcode}) {
    showtimes {
      nextShowing {
        time
        link
      }
      times {
        time
        link
      }
      location
      distance
    }
  }
}
`
module.exports = createQuery
